import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../component/layout';
import DashboardTab from './tabs/dashboardTab';
import ActiveRFQsTab from './tabs/activeRFQsTab';
import ClosedRFQsTab from './tabs/closedRFQsTab';

const SupplierRFQManagement = () => {
  // Tabs: 0 = Dashboard, 1 = Active, 2 = Closed
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Layout title="Supplier RFQ Management">
      <div className="page-header">
        <div className="page-block">
          <div className="row align-items-center">
            <div className="col-md-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={"/facility/rfq_management"}>RFQ Management</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid p-0">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h4 className="mb-0">Supplier RFQ Management</h4>
              </div>
              <div className="card-body">
                <div className="row mb-3">
                  <div className="col-md-3 col-xs-12">
                    <input
                      className="form-control"
                      placeholder="Search RFQs by number or name"
                    />
                  </div>
                  <div className="col-md-3 col-xs-12">
                    <div className="btn-group-dropdown">
                      <button
                        className="btn btn-outline-default dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i className="ti ti-filter"></i> Filter
                      </button>
                      <div className="dropdown-menu">
                        <Link className="dropdown-item" to="#!">
                          All
                        </Link>
                        <Link className="dropdown-item" to="#!">
                          Active
                        </Link>
                        <Link className="dropdown-item" to="#!">
                          Closed
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Tabs */}
                <div className="mb-4">
                  <div className="card">
                    <div className="card-body py-0">
                      <ul className="nav nav-tabs profile-tabs" id="myTab" role="tablist">
                        <li className="nav-item">
                          <button
                            className={`nav-link ${activeTab === 0 ? 'active' : ''}`}
                            onClick={() => setActiveTab(0)}
                            role="tab"
                          >
                            <i className="ti ti-dashboard me-2"></i>Dashboard
                          </button>
                        </li>
                        <li className="nav-item">
                          <button
                            className={`nav-link ${activeTab === 1 ? 'active' : ''}`}
                            onClick={() => setActiveTab(1)} 
                            role="tab"
                          >
                            <i className="ti ti-check me-2"></i>Active RFQs
                          </button>
                        </li>
                        <li className="nav-item">
                          <button
                            className={`nav-link ${activeTab === 2 ? 'active' : ''}`}
                            onClick={() => setActiveTab(2)} 
                            role="tab"
                          >
                            <i className="ti ti-archive me-2"></i>Closed RFQs
                          </button>
                        </li>
                      </ul>

                    </div>
                  </div>
                </div>

                {/* Tab content */}
                <div>
                  {activeTab === 0 && <DashboardTab />}
                  {activeTab === 1 && <ActiveRFQsTab />}
                  {activeTab === 2 && <ClosedRFQsTab />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SupplierRFQManagement;